var found_swl = setInterval(function(){



        if( $("body.collection  .slider-category").length ){
            clearInterval(found_swl);
        }



 $(document).ready(function () {

            $('body.collection  .slider-category').slick({
              dots: false,
              infinite: false,
              speed: 300,
               arrows: false,
              slidesToShow: 7,
              slidesToScroll: 3,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                }
               
              ]
            });
    
    
    
    
          }, 200);
        
    
    
    });



